import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The type scale, declared to tailwind-merge as font sizes.
 *
 * Without this it guesses: an unknown `text-*` is treated as a *colour*, so
 * `cn("text-accent-fg", "text-body")` kept the size and silently threw the
 * colour away — which is how a white button label turned black. Every custom
 * utility named `text-…` in `index.css` has to be listed here.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "title-1",
            "title-2",
            "title-3",
            "body",
            "callout",
            "subhead",
            "footnote",
            "eyebrow",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Split a permission codename at its `__` separator: `view__group` → ["view", "group"]. */
export function splitCodename(codename: string): [action: string, model: string] {
  const index = codename.indexOf("__");
  if (index === -1) return ["", codename];
  return [codename.slice(0, index), codename.slice(index + 2)];
}

export function humanise(value: string): string {
  return value.replaceAll("_", " ");
}

/** "4m 49s", or "49s" under a minute. A clock reading nobody has to decode. */
export function formatWait(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return minutes > 0 ? `${minutes}m ${rest}s` : `${rest}s`;
}
